import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

const routeList: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'index',
    component: () => import('../layout/indexPage.vue'),
    redirect: '/home',
    children: [
      {
        path: '/home',
        name: 'home',
        component: () => import('../views/homePage.vue'),
        meta: {
          title: '首页',
        }
      },
      {
        path: '/detail',
        name: 'detail',
        component: () => import('../views/product/detailPage.vue'),
        meta: {
          title: '产品详情',
        }
      },
      {
        path: '/testPage',
        name: 'testPage',
        component: () => import('../views/testPage.vue'),
        meta: {
          title: '产品详情',
        }
      },
      {
        path: '/drone',
        name: 'drone',
        component: () => import('../views/DroneShowcase/index.vue'),
        meta: {
          title: 'X-2000 Drone',
        }
      },
      {
        path: '/drone/solution-b',
        name: 'drone-solution-b',
        component: () => import('../views/DroneShowcase/SolutionB.vue'),
        meta: {
          title: '智慧城市解决方案',
        }
      },
      {
        path: '/cloud-case',
        name: 'cloud-case',
        component: () => import('../views/CloudCase/index.vue'),
        meta: {
          title: '数智云案',
        }
      },
      {
        path: '/cloud-case/detail/:id',
        name: 'cloud-case-detail',
        component: () => import('../views/CloudCase/Detail.vue'),
        meta: {
          title: '数智云案详情',
        }
      }
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: routeList,

})
export default router
